import React, { createContext, useContext, useState } from 'react';

const BrochureModalContext = createContext();

export const useBrochureModal = () => {
  const context = useContext(BrochureModalContext);
  if (!context) {
    throw new Error('useBrochureModal must be used within BrochureModalProvider');
  }
  return context;
};

export const BrochureModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('');

  const openModal = (language = '') => {
    setSelectedLanguage(language);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLanguage('');
  };

  return (
    <BrochureModalContext.Provider value={{ isModalOpen, selectedLanguage, openModal, closeModal }}>
      {children}
    </BrochureModalContext.Provider>
  );
};
